/** Offices allowed to use the Financeiro module in production (beta rollout). */
export const FINANCE_BETA_OFFICE_IDS = [1, 4];

export function getStoredUser() {
  try {
    const raw = localStorage.getItem("user");
    if (!raw || raw === "undefined") return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/**
 * Returns true when the office (owner_id || id) is in the finance beta allowlist.
 * Employees of allowed offices are included via owner_id.
 */
export function canAccessFinanceModule(user = getStoredUser()) {
  if (!user) return false;
  const officeId = Number(user.owner_id || user.id);
  return FINANCE_BETA_OFFICE_IDS.includes(officeId);
}
